var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.5 15.5c0 1.703-.24 3.047-.733 4.09-.508 1.071-1.26 1.776-2.17 2.212-.878.422-1.86.572-2.808.635-.928.062-1.979.043-2.906.063h-2.766c-.927-.02-1.978-.001-2.906-.063-.948-.063-1.93-.213-2.808-.635-.91-.436-1.662-1.14-2.17-2.212-.493-1.043-.733-2.387-.733-4.09a1 1 0 1 1 2 0c0 1.539.22 2.557.541 3.234.307.648.722 1.022 1.228 1.265.537.257 1.219.386 2.074.442.875.058 1.767.037 2.817.059h2.68c1.05-.022 1.942-.001 2.817-.059.855-.056 1.537-.185 2.074-.442.506-.243.921-.617 1.228-1.265.32-.677.541-1.695.541-3.234a1 1 0 1 1 2 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.707 7.293a1 1 0 0 1-1.414 1.414L13.5 5.914V16.5a1 1 0 0 1-2 0V5.914L8.707 8.707a1 1 0 0 1-1.414-1.414l4.5-4.5.076-.069a1 1 0 0 1 1.338.069z"
  })));
};
export default Svg24;